var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccepted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check_circle_outline_24px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/action/check_circle_outline_24px",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99967 1.33301C4.31967 1.33301 1.33301 4.31967 1.33301 7.99967C1.33301 11.6797 4.31967 14.6663 7.99967 14.6663C11.6797 14.6663 14.6663 11.6797 14.6663 7.99967C14.6663 4.31967 11.6797 1.33301 7.99967 1.33301ZM7.99967 13.333C5.05967 13.333 2.66634 10.9397 2.66634 7.99967C2.66634 5.05967 5.05967 2.66634 7.99967 2.66634C10.9397 2.66634 13.333 5.05967 13.333 7.99967C13.333 10.9397 10.9397 13.333 7.99967 13.333ZM6.66634 9.44634L11.0597 5.05301L11.9997 5.99967L6.66634 11.333L3.99967 8.66634L4.93967 7.72634L6.66634 9.44634Z",
    fill: "#51AF53"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccepted);
export default __webpack_public_path__ + "static/media/accepted.df7cacee70f4eacd536d210e31aaab24.svg";
export { ForwardRef as ReactComponent };